module.exports = __webpack_public_path__ + "static/media/CosmoRoundLogo.5f85dd5f.png";